import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { DeleteOutlined, DownloadOutlined, VisibilityOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

interface CustomerProductFileRowDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  onView: () => void
  onDownload: () => void
  onRemove: () => void
}

export const CustomerProductFileRowDropdownMenu: FC<CustomerProductFileRowDropdownMenuProps> = ({
  anchorEl,
  onClose,
  onView,
  onDownload,
  onRemove,
}) => {
  return (
    <Menu anchorEl={anchorEl} open onClose={onClose} data-testid='customer-product-file-row-dropdown-menu'>
      <MenuItem onClick={onView} data-testid='customer-product-file-view-menu-item'>
        <ListItemIcon>
          <VisibilityOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='View Document' />
      </MenuItem>
      <MenuItem onClick={onDownload} data-testid='customer-product-file-download-menu-item'>
        <ListItemIcon>
          <DownloadOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Download' />
      </MenuItem>
      <MenuItem onClick={onRemove} data-testid='customer-product-file-delete-menu-item'>
        <ListItemIcon>
          <DeleteOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Delete Document' />
      </MenuItem>
    </Menu>
  )
}
